import React, { useState } from 'react'
import './election-creator.css'

interface ElectionParams {
  title: string
  description: string
  durationDays: number
  minParticipation: number
  minSupport: number
  maxVoteOverwrites: number
  anonymous: boolean
  secretUntilTheEnd: boolean
}

interface ElectionCreatorProps {
  onCreateElection: (params: ElectionParams) => void
}

export function ElectionCreator({ onCreateElection }: ElectionCreatorProps) {
  const [params, setParams] = useState<ElectionParams>({
    title: '',
    description: '',
    durationDays: 10,
    minParticipation: 25,
    minSupport: 50,
    maxVoteOverwrites: 0,
    anonymous: false,
    secretUntilTheEnd: false
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onCreateElection(params)
  }

  const handleChange = (field: keyof ElectionParams, value: string | number | boolean) => {
    setParams(prev => ({ ...prev, [field]: value }))
  }

  return (
    <div className="election-creator">
      <h2>Create Election</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Election Title:</label>
          <input
            id="title"
            type="text"
            value={params.title}
            onChange={(e) => handleChange('title', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Election Description:</label>
          <textarea
            id="description"
            value={params.description}
            onChange={(e) => handleChange('description', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="durationDays">Duration (days):</label>
          <input
            id="durationDays"
            type="number"
            min="1"
            max="30"
            value={params.durationDays}
            onChange={(e) => handleChange('durationDays', parseInt(e.target.value))}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="minParticipation">Minimum Participation (%):</label>
          <input
            id="minParticipation"
            type="number"
            min="0"
            max="100"
            value={params.minParticipation}
            onChange={(e) => handleChange('minParticipation', parseInt(e.target.value))}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="minSupport">Minimum Support Required (%):</label>
          <input
            id="minSupport"
            type="number"
            min="0"
            max="100"
            value={params.minSupport}
            onChange={(e) => handleChange('minSupport', parseInt(e.target.value))}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="maxVoteOverwrites">Max Vote Changes Allowed:</label>
          <input
            id="maxVoteOverwrites"
            type="number"
            min="0"
            value={params.maxVoteOverwrites}
            onChange={(e) => handleChange('maxVoteOverwrites', parseInt(e.target.value))}
            required
          />
        </div>

        <div className="form-group checkbox">
          <label>
            <input
              type="checkbox"
              checked={params.anonymous}
              onChange={(e) => handleChange('anonymous', e.target.checked)}
            />
            Anonymous Voting
          </label>
        </div>

        <div className="form-group checkbox">
          <label>
            <input
              type="checkbox"
              checked={params.secretUntilTheEnd}
              onChange={(e) => handleChange('secretUntilTheEnd', e.target.checked)}
            />
            Keep Results Secret Until End
          </label>
        </div>

        <button type="submit" className="create-button">
          Create Election
        </button>
      </form>
    </div>
  )
} 